import * as Yup from 'yup';

export type ValidationRules<T extends string> = Record<T, Yup.Schema<any>>;

export function createFormConfig<T>(
  validationRules: ValidationRules<keyof T & string>,
  defaultValues?: Partial<Record<keyof T & string, any>>
) {
  const initialValues = Object.fromEntries(
    Object.keys(validationRules).map((key) => {
      const schema = validationRules[key as keyof T & string];

      let defaultValue: any;

      if (defaultValues?.hasOwnProperty(key)) {
        defaultValue = defaultValues[key as keyof T & string];
      } else if (schema instanceof Yup.BooleanSchema) {
        defaultValue = false;
      } else if (schema instanceof Yup.NumberSchema) {
        defaultValue = 0;
      } else if (schema instanceof Yup.DateSchema) {
        defaultValue = null;
      } else if (schema instanceof Yup.ArraySchema) {
        defaultValue = [];
      } else {
        defaultValue = '';
      }

      return [key, defaultValue];
    })
  ) as Record<keyof T, any>;

  const validationSchema = Yup.object(
    validationRules
  ) as Yup.ObjectSchema<Record<keyof T, Yup.AnySchema>>;

  return { initialValues, validationSchema };
}
